interface DataType {
   id: number;
   page: string;
   thumb: string;
   name: string;
   tag: string;
};

const instructor_data: DataType[] = [
   {
      id: 1,
      page: "home_4",
      thumb: "/assets/img/instructor/h4_instructor01.jpg",
      name: "Layla Santiago",
      tag: "Pilates Instructor",
   },
   {
      id: 2,
      page: "home_4",
      thumb: "/assets/img/instructor/h4_instructor02.jpg",
      name: "ZenVib Yoga",
      tag: "Pilates Instructor",
   },
   {
      id: 3,
      page: "home_4",
      thumb: "/assets/img/instructor/h4_instructor03.jpg",
      name: "Zenni Motion",
      tag: "Pilates Instructor",
   },
   {
      id: 4,
      page: "home_4",
      thumb: "/assets/img/instructor/h4_instructor04.jpg",
      name: "Joyful Zen",
      tag: "Pilates Instructor",
   },

   // home_5

   {
      id: 1,
      page: "home_5",
      thumb: "/assets/img/instructor/h5_instructor01.jpg",
      name: "Wade Warren",
      tag: "Sports Teacher",
   },
   {
      id: 2,
      page: "home_5",
      thumb: "/assets/img/instructor/h5_instructor02.jpg",
      name: "Cody Fisher",
      tag: "Sports Teacher",
   },
   {
      id: 3,
      page: "home_5",
      thumb: "/assets/img/instructor/h5_instructor03.jpg",
      name: "Dianne Russell",
      tag: "Sports Teacher",
   },
   {
      id: 4,
      page: "home_5",
      thumb: "/assets/img/instructor/h5_instructor04.jpg",
      name: "Jerome Bell",
      tag: "Sports Teacher",
   },
];

export default instructor_data;